module.exports = new __parcel__URL__("the-binding-of-isaac-rebirth.abca5131.jpg").toString();